require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-12-of-the-best-drinks-brands-on-shopify.json") })
        }
      }, "path---blog-12-of-the-best-drinks-brands-on-shopify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-12-of-the-best-drinks-brands-on-shopify!./.cache/json/blog-12-of-the-best-drinks-brands-on-shopify.json
// module id = 380
// module chunks = 231608221292675